var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.basicInformation"
              )
            ) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddWarehouse.supportWarehouseType"
                        ),
                        prop: "supportWarehouseType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "constant-key": "STOCK_WAREHOUSE_TYPE_SON_4_LIST",
                        },
                        on: { change: _vm.onChangeSupportWarehouseType },
                        model: {
                          value: _vm.form.supportWarehouseType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseType", $$v)
                          },
                          expression: "form.supportWarehouseType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddWarehouse.supportWarehouseId"
                        ),
                        prop: "supportWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { "type-code": _vm.supportTypeCodeList },
                        on: { change: _vm.onChangeSupportWarehouseId },
                        model: {
                          value: _vm.form.supportWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseId", $$v)
                          },
                          expression: "form.supportWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddWarehouse.supportWarehouseCode"
                        ),
                        prop: "supportWarehouseCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: "",
                          value: _vm.form.supportWarehouseCode,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.commodityDetails"
              )
            ) + " "
          ),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogListGoodsShow()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionRatioAddWarehouse.addGoods"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableDataSku,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "categoryName",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.categoryName"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              align: "center",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.skuCode"
              ),
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("table.operationText"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteSku(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BusinessStockDistributionRatioAddWarehouse.receivingWarehouse"
            )
          ) + " "
        ),
      ]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableDataWarehouse,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveTypeCode",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.receiveTypeCode"
              ),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(
                            scope.row.receiveTypeCode
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveCode",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.receiveCode"
              ),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "receiveName",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.receiveName"
              ),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "structureDistributionQty",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.distributionQty"
              ),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " + _vm._s(props.row.structureDistributionQty) + " % "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "distributionQty",
              label: _vm.$t(
                "BusinessStockDistributionRatioAddWarehouse.table.distributionQty"
              ),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjInput", {
                      staticStyle: { width: "50px" },
                      attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                      model: {
                        value: props.row.distributionQty,
                        callback: function ($$v) {
                          _vm.$set(props.row, "distributionQty", $$v)
                        },
                        expression: "props.row.distributionQty",
                      },
                    }),
                    _vm._v(" % "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("table.operationText"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDeleteWarehouse(
                              scope.row,
                              scope.$index
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: { config: _vm.dialogListGoodsConfig },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }